import { Pipe, PipeTransform, inject } from '@angular/core';
import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe, DatePipeConfig } from '@angular/common';

@Pipe({
  name: 'dateTime',
  standalone: true
})
export class DateTimePipe implements PipeTransform {
  private datePipe = inject(DatePipe);
  private defaultOptions = inject<DatePipeConfig>(DATE_PIPE_DEFAULT_OPTIONS);

  transform(value: string | Date): string {
    return `${this.datePipe.transform(value)} ${this.datePipe.transform(value, 'HH:mm')}`;
  }
}
